import * as React from 'react';
import { Link, useRouter } from 'next-translate-routes-multi-domain';
import { isLocaleGerman } from '@/lib/data-transformer/gindumacUtils';
import LegalLayout from '@/components/layout/LegalLayout';

export default function LogisticsServicesPage() {
  const { locale } = useRouter();
  return (
    <LegalLayout>
      {!isLocaleGerman(locale) ? (
        <>
          <h1>Cookies policy of GINDUMAC</h1>
          <span className='date'>Updated 25.05.2018</span>

          <ul className='space-y-4'>
            <li>
              <h2>What is a cookie?</h2>
            </li>
            <p>
              A cookie is a small text file, which is stored in the interim
              storage of the browser of the user or customer and which enables
              an analysis of the use of the <strong>GM</strong> website by the
              user or customer. The following data will be entered automatically
              by the <strong>GM</strong> computer system through cookies when
              the websites are called:
            </p>
            <ul>
              <li>- The Internet address (IP address) of the user/customer,</li>
              <li>- Browser type and version,</li>
              <li>
                - Website, from which the user/customer visits the website of
                GINDUMAC GmbH (Referrer URL)
              </li>
              <li>- Used operating system,</li>
              <li>
                - Website from which the user/customer is forwarded to other
                websites,
              </li>
              <li>- Date and time of the access.</li>
            </ul>
            <li>
              <h2>Automatic data entry by cookies</h2>
            </li>
            <p>
              At GINDUMAC we use cookies to manage the preferences of users,
              collect analytical and usage data, and improve the overall user
              experience.
            </p>
            <p>
              These data are stored separately from the other data of the user
              or customers, who voluntarily provide these to <strong>GM</strong>
              . These data are not linked with the voluntarily submitted data of
              the user or customer. These data are merely evaluated for
              statistical purposes in order to be able to optimize the{' '}
              <strong>GM</strong> websites and their offers. The data will be
              deleted after their evaluation.
            </p>
            <p>
              Should the user or customer not request the use of the cookies he
              can block the use in his browser.
            </p>

            <li>
              <h2>Managing cookies</h2>
            </li>
            <p>
              You can manage website cookies in your browser settings, and you
              always have the choice to change these settings by accepting,
              rejecting, or deleting cookies. All browser settings are
              different, so to manage cookies, you should refer to the relevant
              settings within your browser.
            </p>
            <p>
              Please find next an overview on how to disable and delete cookies
              in some commonly used browsers:
            </p>
            <p>
              {`For Microsoft Internet Explorer, go to "Tools", select "Internet
              Options" and then "Privacy".`}
            </p>
            <p>
              {`For Mozilla Firefox, for Mac users, go to "Preferences", select
              "Privacy" and then "Show Cookies". For Windows users, go to
              "Tools", select "Options", then "Privacy" and finally "Use custom
              settings for history".`}
            </p>
            <p>{`For Safari, go to "Preferences", then select "Privacy".`}</p>
            <p>
              {`For Google Chrome, go to "Tools", select "Options" ("Preferences"
              in the case of Mac users), then "Advanced" and finally "Content
              Settings" under the Privacy section and tick on "Cookies" in the
              "Content Settings" dialog box.`}
            </p>

            <li>
              <h2>Contact information</h2>
            </li>
            <p>
              If you have any questions regarding the use of local portal
              storage you can find our contact details in our{' '}
              <Link href={`/privacy`}>Privacy Policy</Link>.
            </p>
          </ul>
        </>
      ) : (
        <>
          <h1>GINDUMAC Cookie-Richtlinie</h1>
          <span className='date'>Stand 25.05.2018</span>

          <ul className='space-y-4'>
            <li>
              <h2>Was sind Cookies?</h2>
            </li>
            <p>
              Ein Cookie ist eine kleine Textdatei, die im Zwischenspeicher des
              Internetbrowsers des Nutzers bzw. Kunden gespeichert wird. Sie
              ermöglicht die Analyse der Nutzung der Website von{' '}
              <strong>GM</strong> durch den Nutzer bzw. Kunden. Folgende Daten
              werden von <strong>GM</strong> automatisch bei Aufruf der
              Webseiten über Cookies erfasst:
            </p>
            <ul>
              <li>- Die Internetadresse (IP-Adresse) des Nutzers/Kunden,</li>
              <li>- Browsertyp und -version,</li>
              <li>
                - Webseite, von der aus der Nutzer/Kunde die Webseite der
                GINDUMAC GmbH besucht (Referrer URL)
              </li>
              <li>- Verwendetes Betriebssystem,</li>
              <li>
                - Webseite von der aus der Nutzer/Kunde auf andere Webseiten
                weitergeleitet wird,
              </li>
              <li>- Datum und Uhrzeit des Zugriffs.</li>
            </ul>

            <li>
              <h2>Automatische Datenerfassung durch Cookies</h2>
            </li>
            <p>
              Bei GINDUMAC setzen wir Cookies ein, um die Präferenzen von
              Nutzern zu verwalten, um Analyse- und Nutzungsdaten zu sammeln und
              die allgemeine Nutzerfreundlichkeit zu verbessern.
            </p>
            <p>
              Diese Daten werden getrennt von den weiteren Daten des Nutzers
              bzw. Kunden, die dieser <strong>GM</strong> freiwillig überlässt,
              gespeichert. Es erfolgt keine Verknüpfung dieser Daten mit den
              freiwillig abgegebenen Daten des Nutzers bzw. Kunden. Diese Daten
              werden lediglich zu statistischen Zwecken ausgewertet, um die{' '}
              <strong>GM</strong>-Webseiten und deren Angebote optimieren zu
              können. Die Daten werden nach ihrer Auswertung gelöscht.
            </p>

            <li>
              <h2>Verwaltung von Cookies</h2>
            </li>
            <p>
              Sie können Website-Cookies in Ihren Browsereinstellungen
              verwalten. An dieser Stelle haben Sie die Möglichkeit diese
              Einstellungen zu ändern und Cookies entweder zu akzeptieren,
              abzulehnen oder zu löschen. Da alle Browsereinstellungen
              unterschiedlich sind, sollten Sie zur Verwaltung von Cookies die
              entsprechenden Einstellungen Ihres Browsers beachten.
            </p>
            <p>
              Nachfolgend finden Sie eine Übersicht, wie Sie Cookies in einigen
              gängigen Browsern deaktivieren und löschen können:
            </p>
            <p>
              Wenn Sie Microsoft Internet Explorer benutzen, wählen Sie in der
              Option des Menüs „Extras” „Internetoptionen” und rufen
              „Privatsphäre” auf.
            </p>
            <p>
              Wenn Sie Firefox für Mac verwenden, wählen Sie im Menü
              „Präferenzen” „Privatsphäre”, rufen den Abschnitt „Cookies zeigen”
              auf. Für Windows wählen Sie im Menü „Extras” „Optionen”, rufen
              „Privatsphäre” auf und danach „Personalisierte Konfiguration für
              den Verlauf anwenden”.
            </p>
            <p>
              Wenn Sie Safari verwenden, wählen Sie im Menü „Präferenzen” den
              Abschnitt „Privatsphäre”.
            </p>
            <p>
              Wenn Sie Google Chrome verwenden, wählen Sie im Menü „Extras”
              „Optionen” (bei Mac „Präferenzen”), rufen „Erweiterte Optionen”
              auf, und dann wählen Sie die Option „Konfiguration Inhalt des
              Abschnitts Privatsphäre”. Zum Schluss markieren Sie „Cookies” im
              Dialog „Konfiguration des Inhalts”.
            </p>

            <li>
              <h2>Kontaktinformationen</h2>
            </li>
            <p>
              Sollten Sie weitere Fragen bezüglich der Nutzung des lokalen
              Portalspeichers haben, finden Sie unsere Kontaktdaten in unserer{' '}
              <Link href='/privacy'>Datenschutzerklärung</Link>.
            </p>
          </ul>
        </>
      )}
    </LegalLayout>
  );
}
